import React, {useState, useEffect} from 'react';
import ShowAScreen from './ScreenComponents/ShowAScreen';
import * as CoreFns from './utilities/CoreFns';
import * as InteractionFns from './InteractionFns';
import { useAccount } from 'wagmi'
import { useWriteContract } from 'wagmi'
import { useWatchContractEvent } from 'wagmi'

import {
  useConnectModal,
  useChainModal
} from '@rainbow-me/rainbowkit';
import { useReadContracts, useBalance, useDisconnect } from 'wagmi';

/* global BigInt */

function App(props) {

  var currentList = props.currentList;
  var setAppInfo = props.setAppInfo;
  var width = props.width;
  var overallWidth = props.overallWidth;
  var height = props.height;
  var appInfo = props.appInfo;
  var startFE = CoreFns.getStartFE(currentList);
  var overlays = props.overlays;
  var programSetID = props.programSetID;
  var ownVariables = props.ownVariables;
  var setOwnVariables = props.setOwnVariables;
  var musicStatus = props.musicStatus;
  var setMusicStatus = props.setMusicStatus;
  var run = props.run;
  var offsetLeft = props.offsetLeft;
  var offsetTop = props.offsetTop;
  var chains = props.chains;
  var urlHeader = props.urlHeader;

  const [chainInfo, setChainInfo] = useState({});
  const [contractEvents, setContractEvents] = useState({});
  const [otherInfo, setOtherInfo] = useState({});
  const [currentPreviewFE, setPreviewFE] = useState(startFE);
  const [screenRefs, setScreenRefs] = useState({});
  const [popUps, setPopUps] = useState([]);

  function setSomething(newInputValues, setWhat){
    appInfo[setWhat] = newInputValues;
    setAppInfo(appInfo);
  }

  function setInputValues(newInputValues){
    return setSomething(newInputValues, 'inputValues');
  }

  function setAlertVisibility(newInputValues){
    return setSomething(newInputValues, 'alertVisibility');
  }

  const { openConnectModal } = useConnectModal();
  const { openChainModal } = useChainModal();
  const { writeContract } = useWriteContract();
  const { address, isConnected, chain } = useAccount();
  var chainId = 0;
  if (chain){
    chainId = chain.id;
  }

  var contracts = [];

  var chainInfoKeys = Object.keys(chainInfo);
  chainInfoKeys.forEach((aChainInfoKey, index)=>{
    var thisInfo = chainInfo[aChainInfoKey];
    var functionKeys = Object.keys(thisInfo);
    functionKeys.forEach((aFunctionKey, index2)=>{
      var thisFunction = thisInfo[aFunctionKey];
      var argKeys = Object.keys(thisFunction);
      argKeys.forEach((anArgKey, index3)=>{
        var thisArgSet = thisFunction[anArgKey];
        if (anArgKey === '_'){
        //   console.log(thisArgSet);
          if (thisArgSet && thisArgSet['xXXxxxxXXXX123xxxx']){
            contracts.push(thisArgSet['xXXxxxxXXXX123xxxx']);
          }
        }else{
          var replyKeys = Object.keys(thisArgSet);
          var firstReplyKey = replyKeys[0];
          var thisRepl = thisArgSet[firstReplyKey];
          if (thisRepl && thisRepl['xXXxxxxXXXX123xxxx']){
            contracts.push(thisRepl['xXXxxxxXXXX123xxxx']);
          }

        }
      })
    })
  })

  const contractResults = useReadContracts({contracts});
  const { disconnect } = useDisconnect()

  if (contractResults.status === 'success'){

    var pointer = 0;

    var chainInfoKeys = Object.keys(chainInfo);
    chainInfoKeys.forEach((aChainInfoKey, index)=>{
      var thisInfo = chainInfo[aChainInfoKey];
      var functionKeys = Object.keys(thisInfo);
      functionKeys.forEach((aFunctionKey, index2)=>{
        var thisFunction = thisInfo[aFunctionKey];
        var argKeys = Object.keys(thisFunction);
        argKeys.forEach((anArgKey, index3)=>{
          var thisArgSet = thisFunction[anArgKey];
          if (anArgKey === '_'){
          //   console.log(thisArgSet);
            if (thisArgSet && thisArgSet['xXXxxxxXXXX123xxxx']){
              var thisData = contractResults.data[pointer];
              if (thisData && thisData.status === 'success'){
                var defaultSlate = {};
                var abi = thisArgSet.origAbi;
                var point = thisArgSet.point;
                var value = thisData.result;
                if (abi.outputs.length === 1){
                  defaultSlate['_'] = coverValueIfNecc(abi.outputs[0].type, value);
                }else{
                  for (var i = 0; i < abi.outputs.length; i++){
                    var aVal = coverValueIfNecc(abi.outputs[i].type, value[i]);
                    defaultSlate['_'+abi.outputs[i].name] = aVal;
                  }
                }
                defaultSlate.checked = true;
                replacement(point, chainInfo, defaultSlate);
                setChainInfo({...chainInfo});
              }
              pointer = pointer + 1;
            }            

          }else{
            var thisArgSet = thisFunction[anArgKey];
            var replyKeys = Object.keys(thisArgSet);
            var firstReplyKey = replyKeys[0];
            var thisRepl = thisArgSet[firstReplyKey];
            if (thisRepl && thisRepl['xXXxxxxXXXX123xxxx']){
              var thisData = contractResults.data[pointer];
              if (thisData && thisData.status === 'success'){
                var defaultSlate = {};
                var abi = thisRepl.origAbi;
                var point = thisRepl.point;
                var value = thisData.result;
                if (abi.outputs.length === 1){
                  defaultSlate['_'] = coverValueIfNecc(abi.outputs[0].type, value);
                }else{
                  for (var i = 0; i < abi.outputs.length; i++){
                    var aVal = coverValueIfNecc(abi.outputs[i].type, value[i]);
                    defaultSlate['_'+abi.outputs[i].name] = aVal;
                  }
                }
                defaultSlate.checked = true;
                replacement(point, chainInfo, defaultSlate);
                setChainInfo({...chainInfo});
              }
              pointer = pointer + 1;
            }            
          }

        })
      })
    })
  }

  var addressForBalance = {};

  if (chainInfo && chainInfo.nativeBalance){
    var aN = chainInfo.nativeBalance;
    var nativeRequests = Object.keys(aN);
    nativeRequests.forEach((aNativeRequest, index)=>{
      if (aNativeRequest){
        var thisP = nativeRequests[aNativeRequest];
        if (thisP && thisP.checked){
        }else{
          addressForBalance = {address:aNativeRequest};
        }        
      }
    })
  }

  const resultX = useBalance(addressForBalance);
  if (chainInfo && chainInfo.nativeBalance){
    if (resultX.status === 'success'){
      var nativeBalance = chainInfo.nativeBalance;
      nativeBalance[addressForBalance.address] = {k:resultX.data.value, checked:true}; 
    }
  }

  function replacement(list, chainInfo, object){
    var p = chainInfo;
    for (var i = 0; i < list.length; i++){
      if (i === list.length - 1){
        p[list[i]] = object;
      }else{
        p = p[list[i]];
      }
    }
  }

  function coverValueIfNecc(type, value){
    if (type.indexOf('[') > -1){
      var prior = type.substr(0, type.indexOf('['));
      return value.map((aVal, index)=>{
        return coverValueIfNecc(prior, aVal);
      })
    }else if (type.indexOf('uint') === 0 || type.indexOf('int') === 0){
      if (!value.hex){
        return BigInt(value);
      }
    }
    return value;
  }

  var contractEvent = {};
  var aCEvent = Object.keys(contractEvents);
  if (aCEvent.length > 0){
    contractEvent = contractEvents[aCEvent[0]];
  }
  useWatchContractEvent(contractEvent);  

  var actChainId = CoreFns.relevantChainId(currentList);
  function initSim(){
    console.log('x');
    if (isConnected){
      if (chainId === actChainId){
        disconnect();
      }else{
        openChainModal();
      }
    }else{
      openConnectModal();
    }
    setChainInfo({});
  }

  var addressOut = '';
  if (isConnected){
    addressOut = address;
  }

  var inputValues;
  var alertVisibility;
  var urlParamsForExecution;
  var interactionFn;
  var internalVariables;

  if (appInfo){
    internalVariables = appInfo.internalVariables;
    internalVariables['isConnected'] = isConnected;
    internalVariables['activeUser'] = addressOut;
    internalVariables['chainId'] = chainId
    internalVariables['chainInfo'] = chainInfo;
    internalVariables['setChainInfo'] = setChainInfo;
    internalVariables['otherInfo'] = otherInfo;
    internalVariables['setOtherInfo'] = setOtherInfo;
    internalVariables['currentScreen'] = {t:'fe', v:currentPreviewFE};

    inputValues = appInfo.inputValues;
    alertVisibility = appInfo.alertVisibility;
    urlParamsForExecution = appInfo.urlParamsForExecution;


    interactionFn = InteractionFns.doInteractionFn(contractEvents, setContractEvents, writeContract, chains, currentList, internalVariables, width, height, inputValues, setInputValues, ownVariables, setOwnVariables, musicStatus, setMusicStatus, alertVisibility, setAlertVisibility, urlParamsForExecution, urlHeader, initSim, currentPreviewFE, setPreviewFE, screenRefs, popUps, setPopUps, programSetID, setAppInfo, setChainInfo);
  }

  useEffect(()=>{
    var aPossib = 'load';
    var ocSet = currentList.oc;
    if (ocSet && run){
      interactionFn(false, ocSet, aPossib, [], ['oc', aPossib]);
    }

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <ShowAScreen chains={chains} overallWidth={overallWidth} internalVariables={internalVariables} width={width} height={height} currentList={currentList} inputValues={inputValues} setInputValues={setInputValues} alertVisibility={alertVisibility} interactionFn={interactionFn} overlays={overlays} whichFEOrPU={{t:'fe', v:currentPreviewFE}} screenRefs={screenRefs} setScreenRefs={setScreenRefs} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} offsetLeft={offsetLeft} offsetTop={offsetTop} musicStatus={musicStatus} />        

}


export default App;
